export const EXPLORERS = {
    'Tron (TRC20)': 'https://tronscan.org/#/transaction/',
    'BSC (BEP-20)': 'https://bscscan.com/tx/',
    'Ethereum (ERC-20)': 'https://etherscan.io/tx/',
    Bitcoin: 'https://blockchain.com/explorer/transactions/btc/',
    Solana: 'https://solscan.io/tx/',
    Dogecoin: 'https://dogechain.info/tx/',
    Litecoin: 'https://live.blockcypher.com/ltc/tx/',
    Matic: 'https://polygonscan.com/tx/',
    Polkadot: 'https://polkascan.io/polkadot',
    Cardano: 'https://explorer.cardano.org/en/transaction?id=',
    CosmosHub: 'https://www.mintscan.io/cosmos/tx/',
    ArbitrumOne: 'https://arbiscan.io/tx/',
    Optimism: 'https://optimistic.etherscan.io/tx/',
    Ripple: 'https://xrpscan.com/tx/',
    Tron: 'https://tronscan.org/#/transaction/',
    Ethereum: 'https://etherscan.io/tx/',
};
//# sourceMappingURL=blockChainExpolerer.js.map